import React, { useEffect, useState } from "react";
import { useRouter } from "./../util/router";
import NotFoundPage from "../components/general/NotFound";
import AlarmLogContent from "../components/alarms/AlarmLogContent";
import { useUser } from "../util/user";

function AlarmLogPage() {
	const [hasAccess, setHasAccess] = useState(false);
	const router = useRouter();
	const userObj = useUser();

	useEffect(() => {
		if (userObj != null) {
			if (userObj.roles != null && userObj.roles.includes("alarms:_view")) {
				setHasAccess(true);
			}
		} else {
			router.push("/solar/logout");
		}
	}, [userObj]);

	return hasAccess ? <AlarmLogContent /> : <NotFoundPage />;
}

export default AlarmLogPage;
